import * as yup from 'yup';

import { requiredStringField } from '@blockpulse3/web-client/forms';

export const csvFileSchema = yup.object({
  csvFile: requiredStringField,
});

export const csvFileDefaultValue = {
  csvFile: '',
};
